import React, { useContext, useEffect, useState } from 'react'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { EventMetaContext } from '../SingleEvent'
import API from '../../../../services/API'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import { TenantSettingsContext } from '../../../../App'

const PatientSummary = ({ data, setData }) => {
  const { eventMeta } = useContext(EventMetaContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  useEffect(() => {
    API.post('/events/pea/patient-summary', {
      eventID: eventMeta._id,
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data)
        console.log('res', res.data)
      }
    })
  }, [])

  const hasDrafts = data.some((p) => p?.review?.status === 'Draft')

  // "Did it occur at the event?" is only asked on ePCRs (not paper or
  // welfare records), so anything without an answer counts as not recorded.
  const occurredAtEvent = data.filter(
    (x) => x?.incident?.injuryOccurredAtEvent === 'Yes',
  ).length
  const occurredElsewhere = data.filter(
    (x) => x?.incident?.injuryOccurredAtEvent === 'No',
  ).length
  const occurredNotRecorded = data.length - occurredAtEvent - occurredElsewhere

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={2}>
        <Typography variant="title2" fontSize="1rem">
          Patient Contacts
        </Typography>
      </Grid>
      <Grid item xs={12} lg={10} paddingTop={1}>
        <Stack gap={2}>
          <DetailRow
            label="Total Number of Patients"
            fullWidthLabel
            value={parseInt(data?.length || 0)}
          />
          <DetailRow
            label={`Transported to Hospital by ${orgSettings?.orgShortName}`}
            value={
              data.filter(
                (x) =>
                  x?.plan?.ptOutcome ===
                  `Transported to Hospital by ${orgSettings?.orgShortName}`,
              ).length
            }
            fullWidthLabel
          />
          <DetailRow
            label="Injuries / Illnesses that Occurred at the Event"
            value={occurredAtEvent}
            fullWidthLabel
          />
          <DetailRow
            label="Occurred Elsewhere (presented at the event)"
            value={occurredElsewhere}
            fullWidthLabel
          />
          <DetailRow
            label="Occurred at Event — Not Recorded"
            value={occurredNotRecorded}
            fullWidthLabel
          />
          {hasDrafts && (
            <Alert severity="warning" variant="filled">
              There are patient records for this event still in 'Draft'.
            </Alert>
          )}
        </Stack>
      </Grid>
    </Grid>
  )
}

export default React.memo(PatientSummary)
